import React from 'react'
// HEADER
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'

const PlanningEquipe = () => {
    return (
        <div className='container-fluid'>

            {/* HEADER */}
            <HeaderReturn title='Planning' link='/homePageEquipe' />

            planning equipe
        </div>
    )
}

export default PlanningEquipe

